import {
  LAB_RESULT_ESCALATION_REASON_LABEL,
  LAB_RESULT_OPS_CHECKLIST,
  type LabResultEscalationRow,
} from "@care-by-ella/contracts";

// TES-1401 (Ö-473) — one row of "Saknade provsvar" as the table shows it.
// Pure, so the wording is testable without a DOM. For each of Emelie's three
// checklist points, the facts Ella has; the check itself happens outside
// Ella (the lab, the patient, LabPortalen, Webdoc).

function fmtDateTime(iso: string | null): string {
  if (!iso) return "–";
  return new Date(iso).toLocaleString("sv-SE", {
    timeZone: "Europe/Stockholm",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const REMISS_STATUS: Record<string, string> = {
  ordered: "Beställd",
  remiss_sent: "Remiss skickad",
  partial: "Delsvar",
};

export interface LabResultEscalationView {
  orderId: string;
  patientId: string;
  name: string;
  reason: string;
  escalatedAt: string;
  checks: string;
  // One entry per LAB_RESULT_OPS_CHECKLIST point, in that order.
  checklist: Array<{ label: string; facts: string }>;
}

export function labResultEscalationViewRow(
  r: LabResultEscalationRow,
): LabResultEscalationView {
  const [remiss, sampling, transfer] = LAB_RESULT_OPS_CHECKLIST;
  const refs = [
    r.remiss.requisitionRef ? `Remiss-id ${r.remiss.requisitionRef}` : null,
    r.remiss.labPortalenRid
      ? `LabPortalen-id ${r.remiss.labPortalenRid}`
      : null,
  ].filter((s): s is string => s !== null);
  return {
    orderId: r.orderId,
    patientId: r.patientId,
    name: r.patientName ?? "Namn saknas",
    reason: LAB_RESULT_ESCALATION_REASON_LABEL[r.reason],
    escalatedAt: fmtDateTime(r.escalatedAt),
    checks: `${r.check.checkCount} kontroller, senast ${fmtDateTime(
      r.check.lastCheckAt,
    )}`,
    checklist: [
      {
        label: remiss,
        facts: [
          `${REMISS_STATUS[r.remiss.status] ?? r.remiss.status} ${fmtDateTime(
            r.orderedAt,
          )}`,
          ...(refs.length ? refs : ["Inget remiss-id i Ella"]),
        ].join(" · "),
      },
      {
        label: sampling,
        facts: `Patienten uppger provtagning ${fmtDateTime(
          r.check.sampleReportedAt,
        )}`,
      },
      {
        label: transfer,
        facts:
          r.transfer.quarantinedReports > 0
            ? `${r.transfer.quarantinedReports} svar från LabPortalen utan koppling – se LabPortalen`
            : "Inget svar har kommit via LabPortalen. Webdoc kontrolleras manuellt.",
      },
    ],
  };
}
